import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import * as tslib_1 from "tslib";
import { Authority } from "./Authority";
import { AuthorityType } from "./Authority";
import { ClientConfigurationError } from "../error/ClientConfigurationError";
export var B2CTrustedHostList = {};
/**
 * @hidden
 */

var B2cAuthority =
/** @class */
function (_super) {
  tslib_1.__extends(B2cAuthority, _super);

  function B2cAuthority(authority, validateAuthority, authorityMetadata) {
    return _super.call(this, authority, validateAuthority, authorityMetadata) || this;
  }

  Object.defineProperty(B2cAuthority.prototype, "AuthorityType", {
    get: function get() {
      return AuthorityType.B2C;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Returns a promise with the TenantDiscoveryEndpoint
   */

  B2cAuthority.prototype.GetOpenIdConfigurationEndpointAsync = function (telemetryManager, correlationId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      return tslib_1.__generator(this, function (_a) {
        if (!this.IsValidationEnabled || this.IsInTrustedHostList(this.CanonicalAuthorityUrlComponents.HostNameAndPort)) {
          return [2
          /*return*/
          , this.DefaultOpenIdConfigurationEndpoint];
        }

        throw ClientConfigurationError.createUntrustedAuthorityError();
      });
    });
  };
  /**
   * Checks to see if the host is in a list of trusted hosts
   * @param {string} The host to look up
   */


  B2cAuthority.prototype.IsInTrustedHostList = function (host) {
    if (this.IsValidationEnabled && !Object.keys(B2CTrustedHostList).length) {
      throw ClientConfigurationError.createKnownAuthoritiesNotSetError();
    }

    return B2CTrustedHostList[host.toLowerCase()];
  };

  B2cAuthority.B2C_PREFIX = "tfp";
  return B2cAuthority;
}(Authority);

export { B2cAuthority };